import { render, staticRenderFns } from "./commentList.vue?vue&type=template&id=b77b0606&scoped=true&"
import script from "./commentList.vue?vue&type=script&lang=js&"
export * from "./commentList.vue?vue&type=script&lang=js&"
import style0 from "./commentList.vue?vue&type=style&index=0&id=b77b0606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77b0606",
  null
  
)

export default component.exports